import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import {
  canUseCompanyContext,
  matchesAccessContext,
} from "services/utils/companyAccess";
export const UserToken = createSlice({
  name: "token",
  initialState: {
    token: localStorage.getItem("token"),
    userDetails: {
      id: "",
      first_name: "",
      username: "",
      last_name: "",
      email: "",
      type: "",
      firmName: "",
      phonenumber: "",
      approver: "",
      teamlead: "",
      approver_id: "",
      image_url: "",
      department_id: "",
      department_name: "",
      employee_id: "",
    },
    globalSearchValue: "",
    currentLocation: localStorage.getItem("currentScreen")
      ? localStorage.getItem("currentScreen")
      : "Team Workspace",
    currentSubMenu: localStorage.getItem("currentSubMenu")
      ? localStorage.getItem("currentSubMenu")
      : "Home",
    adminCompanyId: localStorage.getItem("adminCompanyId")
      ? JSON.parse(localStorage.getItem("adminCompanyId"))
      : null,
    adminCompanyName: localStorage.getItem("adminCompanyname")
      ? localStorage.getItem("adminCompanyname")
      : "",
    companyList: JSON.parse(localStorage.getItem("companyAccess"))
      ? JSON.parse(localStorage.getItem("companyAccess"))
      : [],
    // Full company records (companyname, isprimary, company_logo_url, ...)
    // from the `company/` endpoint -- companyList above only carries
    // company_id/company_name from the user-group access-check endpoint and
    // can't be used to resolve the primary company's logo.
    companyDetails: (() => {
      try {
        const stored = JSON.parse(localStorage.getItem("companyDetails"));
        return Array.isArray(stored) ? stored : (stored?.results ?? []);
      } catch {
        return [];
      }
    })(),
    topbarCompanyId: localStorage.getItem("topbarCompanyId")
      ? localStorage.getItem("topbarCompanyId")
      : null,
    topbarCompanyName: localStorage.getItem("topbarCompanyName")
      ? localStorage.getItem("topbarCompanyName")
      : "",
    departmentViewMethod: "ListView",
    payrollRunCurrentScreen: "PaySchedule",
    productAccess: null,
    startDate: moment(new Date()).subtract(7, "d").format("DD/MM/YYYY"),
    endDate: moment(new Date()).format("DD/MM/YYYY"),
    // Revalidate grants after reload instead of restoring revoked permissions.
    userScreenAccess: [],
    domain:
      window.location.hostname === "localhost"
        ? `https://strco.venmukil.com/api/`
        : `https://${window.location.hostname}/api/`,
    // Frajun Widget Sta
    frajunPhoneNumber: "",
    frajunContactName: "",
    frajunContactId: null,
    frajunAutoInitiate: false,
    callCompleteContactId: null,
  },
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },

    setCurrentUser: (state, action) => {
      if (String(state.userDetails?.id) !== String(action.payload?.id)) {
        state.userScreenAccess = [];
        state.productAccess = null;
      }
      state.userDetails = action.payload;
    },
    setCurrentLocation: (state, action) => {
      if (state.currentLocation !== action.payload) state.userScreenAccess = [];
      state.currentLocation = action.payload;
    },
    setCurrentSubMenu: (state, action) => {
      state.currentSubMenu = action.payload;
    },
    setDateRange: (state, action) => {
      state.dateRange = action.payload;
    },
    setReduxStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setReduxEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setDomain: (state, action) => {
      state.domain = action.payload;
    },
    setGlobalSearchValue: (state, action) => {
      state.globalSearchValue = action.payload;
    },
    setDepartmentViewMethod: (state, action) => {
      state.departmentViewMethod = action.payload;
    },
    setAdminCompanyId: (state, action) => {
      state.adminCompanyId = action.payload;
    },
    setAdminCompanyName: (state, action) => {
      state.adminCompanyName = action.payload;
    },
    setCompanyList: (state, action) => {
      state.companyList = action.payload;
    },
    setCompanyDetails: (state, action) => {
      state.companyDetails = action.payload;
    },
    setTopbarCompanyId: (state, action) => {
      if (String(state.topbarCompanyId) !== String(action.payload)) {
        state.userScreenAccess = [];
        state.productAccess = null;
      }
      state.topbarCompanyId = action.payload;
    },
    setTopbarCompanyName: (state, action) => {
      state.topbarCompanyName = action.payload;
    },
    setProductAccess: (state, action) => {
      if (action.payload === null) state.productAccess = null;
      else if (
        String(action.payload?.company_id) === String(state.topbarCompanyId)
      ) {
        state.productAccess = Array.isArray(action.payload.products)
          ? action.payload.products
          : [];
      }
    },
    setScreenAccess: (state, action) => {
      if (
        Array.isArray(action.payload) ||
        (canUseCompanyContext(
          state.topbarCompanyId,
          state.userDetails?.type,
          state.companyList,
        ) &&
          matchesAccessContext(
            action.payload,
            state.topbarCompanyId,
            state.currentLocation,
          ))
      ) {
        state.userScreenAccess = action.payload;
      }
    },
    setPayrollRunCurrentScreen: (state, action) => {
      state.payrollRunCurrentScreen = action.payload;
    },
    setVisible: (state, action) => {
      state.visible = action.payload;
    },
    setFrajunPhoneNumber: (state, action) => {
      state.frajunPhoneNumber = action.payload;
    },
    setFrajunContactName: (state, action) => {
      state.frajunContactName = action.payload;
    },
    setFrajunAutoInitiate: (state, action) => {
      state.frajunAutoInitiate = action.payload;
    },
    setFrajunContactId: (state, action) => {
      state.frajunContactId = action.payload;
    },
    setCallCompleteContactId: (state, action) => {
      state.callCompleteContactId = action.payload;
    },
    setCallSoundEnabled: (state, action) => {
      state.callSoundEnabled = action.payload;
      localStorage.setItem("callSoundEnabled", String(action.payload));
    },
    setCallNotificationEnabled: (state, action) => {
      state.callNotificationEnabled = action.payload;
      localStorage.setItem("callNotificationEnabled", String(action.payload));
    },
  },
});

export const {
  setToken,
  setCurrentUser,
  setCurrentLocation,
  setDateRange,
  setReduxStartDate,
  setReduxEndDate,
  setDomain,
  setGlobalSearchValue,
  setCurrentSubMenu,
  setDepartmentViewMethod,
  setAdminCompanyId,
  setAdminCompanyName,
  setTopbarCompanyName,
  setTopbarCompanyId,
  setProductAccess,
  setScreenAccess,
  setPayrollRunCurrentScreen,
  setVisible,
  companyList,
  setCompanyList,
  setCompanyDetails,
  setFrajunPhoneNumber,
  setFrajunContactName,
  setFrajunAutoInitiate,
  setFrajunContactId,
  setCallCompleteContactId,
  setCallSoundEnabled,
  setCallNotificationEnabled,
} = UserToken.actions;

export default UserToken.reducer;
